import EFPicture from 'elem/compCommon/EFPicture';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import IP68 from '@elem/SVGIcon/VanlifeRoadtrips/IP68';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D_NA() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('outdoorrecreation');
    const icons: any = [
        {
            icon: <PortableDesign />,
            text: t('secD_tag1'),
        },
        {
            icon: <PlugAndPlay className="color" />,
            text: t('secD_tag2'),
        },
        {
            icon: <IP68 />,
            text: t('secD_tag3'),
        },
    ];
    return (
        <div id="outdoor-recreation-D" className={`outdoor-recreation-D ${css['outdoor-recreation-D']}`}>
            <div className="img-box">
                <EFPicture
                    src={
                        locale === 'za'
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578854958/4_za.png'
                            : `/responsive/picture/outdoor-recreation/4_1366_na.jpg`
                    }
                    srcDesktop={
                        locale === 'za'
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578854958/4_za.png'
                            : `/responsive/picture/outdoor-recreation/4_1366_na.jpg`
                    }
                    srcPad={
                        locale === 'za'
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578854958/4_za.png'
                            : `/responsive/picture/outdoor-recreation/4_1366_na.jpg`
                    }
                    srcMobile={
                        locale === 'za'
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717579314828/4_375_za.png'
                            : `/responsive/picture/outdoor-recreation/4_375_na.jpg`
                    }
                    alt={t('secD_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secD_title')}</p>
                    <p className="desc">{t('secD_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
